export default __webpack_public_path__ + "static/media/justnaik_full.d27aa836.png";